const RowModelType = {
  SERVER_SIDE: 'serverSide',
};
export default RowModelType;
